import { StoreState } from '../store-interfaces';

export const tourOpenSelector = (state: StoreState) =>
  state.modalState.isTourOpen;

export const isAnyModalOpen = (state: StoreState) => state.modalState.isOpen;

export const canOpenModalSelector = (state: StoreState) =>
  !(state.modalState.isOpen || state.modalState.isOpening);
